<textarea
  class="form-control"
  [formControl]="$any(formControl)"
  [formlyAttributes]="field"
  [class.is-valid]="valid"
  [class.is-invalid]="invalid"
  [class.has-scrollbar]="hasScrollbar"
  [rows]="props.rows"
  (keyup)="onKeyUp($event)"
></textarea>
